import axios from "@/libs/api.request";
import config from "@/config";
import { paramFormat } from "@/api/fn";
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;

/*
export const login = ({ userName, password }) => {
  const data = {
    userName,
    password
  }
}
*/
export const login = data => {
  let apiurl = baseUrl + "/sys/login";
  let param = paramFormat(data);
  return axios.request({
    url: apiurl, // 'login',
    data: param,
    dataType: "json",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    method: "POST"
  });
};

export const sendCheckCode = data => {
  let apiurl = baseUrl + "/sms/sendCheckCode";
  let param = paramFormat(data);
  return axios.request({
    url: apiurl, // 'login',
    data: param,
    dataType: "json",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    method: "POST"
  });
};

export const loginByPhone = data => {
  let apiurl = baseUrl + "/sys/loginByPhone";
  let param = paramFormat(data);
  return axios.request({
    url: apiurl, // 'login',
    data: param,
    dataType: "json",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    method: "POST"
  });
};

export const getMenuList = token => {
  return axios.request({
    url: baseUrl + "/sys/menu/nav",
    method: "GET",
    dataType: "json",
    headers: {
      token: token,
      "Content-Type": "application/json; charset=utf-8"
    }
  });
};
export const getUserInfo = token => {
  return axios.request({
    url: baseUrl + "/sys/menu/nav",
    params: {
      token
    },
    method: "get",
    dataType: "json",
    headers: {
      token: token,
      "Content-Type": "application/json; charset=utf-8"
    }
  });
};

export const logout = token => {
  return axios.request({
    url: baseUrl + "/sys/logout",
    params: {
      token
    },
    method: "POST",
    dataType: "json",
    headers: {
      token: token,
      "Content-Type": "application/json; charset=utf-8",
    }
  });
};
